export default ({ $aditude, store }) => {
	window.dataLayer = window.dataLayer || [];

	// Prevent double-wrapping if plugin is ever re-evaluated
	if (window.dataLayer.__dataLayerPushWrapped) {
		return;
	}

	const oldPushFunction = window.dataLayer.push;

	const hasConsentLoadedAdsInDataLayer = () => {
		// dataLayer is an Array; entries are commonly objects, but can be other types
		return window.dataLayer.some(
			(item) =>
				item &&
				typeof item === "object" &&
				item.event === "consent-loaded" &&
				item.eventPayload === "load-ads"
		);
	};

	const loadAditude = () => {
		const eventName = "libload-aditude";

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({ event: eventName });

		if (
			!store?.getters["features/isFeatureEnabled"]?.("DisableThirdParty")
		) {
			// Double guard just to prevent reloading aditude cuz I was getting an error
			if (window.dataLayer.__aditudeLoaded) {
				return;
			}

			$aditude.loadAditude();
			window.dataLayer.__aditudeLoaded = true;
			console.log("+++ Aditude loaded");
		}
	};

	// 1) Historical guard: if GTM somehow already pushed the consent event before we wrapped the push function
	if (hasConsentLoadedAdsInDataLayer()) {
		loadAditude();
	}

	// 2) Future guard: load aditude when consent is given/reloaded/updated
	window.dataLayer.push = function (...args) {
		if (
			args[0]?.event === "consent-loaded" &&
			args[0]?.eventPayload === "load-ads"
		) {
			loadAditude();
		}

		window.dataLayer.__dataLayerPushWrapped = true;

		// Proceed calling the previous window.dataLayer.push reference as if nothing happened
		const prevArguments = [].slice.call(args, 0);
		return oldPushFunction.apply(window.dataLayer, prevArguments);
	};

	// 3) Explicit load flag
	if (store?.getters["features/isFeatureEnabled"]?.("ImmediateAdLoad")) {
		loadAditude();
	}
};
